import { createSlice } from '@reduxjs/toolkit'
import {AUTH_TOKEN} from "../../constants/AuthConstant";

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	messageType: null,
	token: localStorage.getItem(AUTH_TOKEN) || null,
	user: {}
}

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
        setToken: (state, action) => {
			state.token = action.payload
		},
		setUserData: (state, action) => {
			state.user = action.payload
		},
		setMessage: (state, action) => {
			state.message = action.payload
		},
		setShowMessage: (state, action) => {
			state.showMessage = action.payload
		},
		setMessageType: (state, action) => {
			state.messageType = action.payload
		}
	},
})

export const {
	setToken,
	setUserData,
	setMessage,
	setShowMessage,
	setMessageType
} = userSlice.actions

export default userSlice.reducer